import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TitleChange {
  private readonly _changeTitle: WritableSignal<string> = signal('Mythicism');
  private readonly _changeDescription: WritableSignal<string> = signal(`Mythicism is the stance that Jesus is only a myth and not a historical figure with mutltiple forms of evidence supporting his nonexistence.`);
  readonly current = this._changeTitle.asReadonly();
  readonly currentDescription = this._changeDescription.asReadonly();

  title = (value: string) => {
    const newTitle = value !== '' ? `Mythicism - ${value}` : `Mythicism`;
    this._changeTitle.set(newTitle);
  }

  description = (value: string) => {
    const newDesc = value !== '' ? value : `Mythicism is the stance that Jesus is only a myth and not a historical figure with mutltiple forms of evidence supporting his nonexistence.`;
    this._changeDescription.set(newDesc);
  }
}